import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Checkbox } from '@/components/ui/checkbox';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { AuthLayout } from '@/components/auth/AuthLayout';
import { useAuth } from '@/contexts/AuthContext';
import { formatApiErrorDetail } from '@/utils/authErrors';
import { toast } from 'sonner';

export default function Register() {
  const navigate = useNavigate();
  const { signup } = useAuth();
  const [form, setForm] = useState({ full_name: '', email: '', branch: 'Ana Şube', password: '', confirmPassword: '', rememberMe: true });
  const [loading, setLoading] = useState(false);

  const onChange = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (form.password !== form.confirmPassword) {
      toast.error('Şifre tekrarı eşleşmiyor');
      return;
    }

    setLoading(true);
    try {
      await signup({
        full_name: form.full_name,
        email: form.email,
        branch: form.branch,
        password: form.password,
        remember_me: form.rememberMe,
      });
      toast.success('Hesabınız oluşturuldu');
      navigate('/dashboard');
    } catch (error) {
      toast.error(formatApiErrorDetail(error.response?.data?.detail || error.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Kayıt Ol"
      subtitle="Yeni çalışan hesabınızı email ve şifre ile oluşturun. Varsayılan rol güvenli kullanıcı erişimiyle açılır."
      footer={<span>Hesabın var mı? <Link to="/login" className="font-medium text-sky-700 underline" data-testid="register-login-link">Giriş yap</Link></span>}
    >
      <form onSubmit={handleSubmit} className="space-y-4" data-testid="register-form">
        <div className="space-y-2">
          <Label htmlFor="register-full-name">Ad Soyad</Label>
          <Input id="register-full-name" value={form.full_name} onChange={(e) => onChange('full_name', e.target.value)} required data-testid="register-full-name-input" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="register-email">Email</Label>
          <Input id="register-email" type="email" value={form.email} onChange={(e) => onChange('email', e.target.value)} required data-testid="register-email-input" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="register-branch">Şube</Label>
          <Input id="register-branch" value={form.branch} onChange={(e) => onChange('branch', e.target.value)} required data-testid="register-branch-input" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="register-password">Şifre</Label>
          <Input id="register-password" type="password" value={form.password} onChange={(e) => onChange('password', e.target.value)} required data-testid="register-password-input" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="register-confirm-password">Şifre Tekrar</Label>
          <Input id="register-confirm-password" type="password" value={form.confirmPassword} onChange={(e) => onChange('confirmPassword', e.target.value)} required data-testid="register-confirm-password-input" />
        </div>
        <div className="flex items-center gap-3 rounded-2xl border border-slate-200 px-4 py-3">
          <Checkbox id="register-remember-me" checked={form.rememberMe} onCheckedChange={(checked) => onChange('rememberMe', Boolean(checked))} data-testid="register-remember-me-checkbox" />
          <Label htmlFor="register-remember-me" className="cursor-pointer font-normal">Oturumumu 30 gün açık tut</Label>
        </div>
        <Button type="submit" className="h-11 w-full" disabled={loading} data-testid="register-submit-button">
          {loading ? 'Hesap oluşturuluyor...' : 'Hesap Oluştur'}
        </Button>
      </form>
    </AuthLayout>
  );
}